import { useRouter } from 'next/router';
import { useState } from 'react';
import { trackRegistrationComplete } from 'utils/analytics/analytics';
import { authApiClient } from 'utils/apiClient';
import HttpStatusCode from 'utils/HttpStatusCode';

export const useEmailSignIn = (
  handleSuccessfulLogin: (token: string, name: string) => Promise<void>,
  handleSuccessfulRegistration: (token: string, name: string) => Promise<void>,
  setError: (error?: string) => void
) => {
  const router = useRouter();
  const [isEmailLoading, setIsEmailLoading] = useState(false);
  const [resetPasswordSuccessful, setResetPasswordSuccessful] = useState(false);

  const doEmailSignIn = async (email_address: string, password: string) => {
    setIsEmailLoading(true);
    setError(undefined);

    // setLoading(true);
    const res = await authApiClient.public.login({
      body: {
        email: email_address.trim(),
        password,
      },
    });

    if (res.status === HttpStatusCode.OK) {
      await handleSuccessfulLogin(res.body.token, res.body.player.firstName);
    } else {
      // TODO: Handle errors
      switch ((res as any /* Cast with as any for now, so we end up in the default case */).reason) {
        // case 'GUEST_ACCOUNT':
        //   localStorage.setItem('guest_email_address', res.body.emailAddress);
        //   await router.push('/register');

        // case 'ACCOUNT_CLOSED':
        //   setError(
        //     'This account has been closed. If you have any questions, you can email them to: info@daymade.co.uk.'
        //   );
        //   break;

        // case '2FA_REQUIRED':
        //   setError('This account must login using google sign in');
        //   break;

        // case 'INVALID_CREDENTIALS':
        //   setError(
        //     'The email address and password you provided do not match our records.'
        //   );
        //   break;

        // case 'FACEBOOK_LINKED_ACCOUNT':
        //   setError(
        //     'You have attempted to log into an DAYMADE account that was created using the Continue With Facebook button. Please sign in using the Continue With Facebook button.'
        //   );
        //   break;

        default:
          setError(
            'Something went wrong. Please email us if this issue persists: hello@daymade.co.uk'
          );
          break;
      }
    }
    setIsEmailLoading(false);
  };

  const doEmailRegister = async (
    firstName: string,
    lastName: string,
    email: string,
    phoneNumber: string | null,
    password: string | null,
    referralId: string | null,
    agreedToMarketing: boolean,
    utmParams: Record<string, string>,
    facebookUserId?: string | null,
    googleUserId?: string | null,
    appleUserId?: string | null,
    overrideReferralScheme?: string | null,
    dob?: string | null,
    gender?: string | null
  ) => {
    setIsEmailLoading(true);
    setError(undefined);
    const res = await authApiClient.public.register({
      body: {
        emailAddress: email.trim(),
        password,
        firstName,
        lastName,
        phoneNumber,
        agreedToMarketing,
        utmParameters: utmParams,
        facebookUserId: facebookUserId ?? null,
        googleUserId: googleUserId ?? null,
        appleUserId: appleUserId ?? null,
        dateOfBirth: null,
        inviterId: null,
      },
    });

    if (res.status === HttpStatusCode.OK) {
      // Send GA event.

      trackRegistrationComplete(
        email.trim(),
        res.body.player.referralId,
        firstName,
        lastName
      );

      handleSuccessfulRegistration(res.body.token, firstName);

      setIsEmailLoading(false);
    } else {
      setError(res.body.message);
    }
    setIsEmailLoading(false);
  };

  const onEmailResetPassword = async (_email: string) => {
    throw new Error('Not implemented yet.');
    // setIsEmailLoading(true);
    // const response = await requestPasswordResetEmail(email.toLowerCase());
    // setIsEmailLoading(false);
    // if (response.successful) {
    //   setResetPasswordSuccessful(true);
    // } else if (response.code === 'GUEST_ACCOUNT') {
    //   localStorage.setItem('guest_email_address', response.emailAddress);
    //   await router.push(`/register`);
    // } else {
    //   setError(response.reason);
    // }
  };

  return {
    isEmailLoading,
    resetPasswordSuccessful,
    doEmailSignIn,
    doEmailRegister,
    onEmailResetPassword,
  };
};
